import { createFileRoute } from '@tanstack/react-router';
import { CampaignsWelcomeCreateRouteView } from '@/pages/workspaces/automations/routing';
import { validateWelcomeCreateSearch } from '@/pages/workspaces/automations/welcome/search';
import { LastWorkspaceResolver } from './-components';

/** Creates an untitled automation and opens it. No `appBundle`: this URL has no `journeys` segment. */
function AutomationsWelcomeCreateRoute() {
  const search = Route.useSearch();
  return (
    <LastWorkspaceResolver>
      <CampaignsWelcomeCreateRouteView search={search} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/welcome/create')({
  component: AutomationsWelcomeCreateRoute,
  validateSearch: validateWelcomeCreateSearch,
});
